import { render, staticRenderFns } from "./simpleFlv.vue?vue&type=template&id=58f81e43&scoped=true"
import script from "./simpleFlv.vue?vue&type=script&lang=js"
export * from "./simpleFlv.vue?vue&type=script&lang=js"
import style0 from "./simpleFlv.vue?vue&type=style&index=0&id=58f81e43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f81e43",
  null
  
)

export default component.exports